module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-1000-ceb950c2.png";